import {
  Text,
  View,
  StyleSheet,
  Dimensions,
  RefreshControl,
  Animated,
  Easing
} from 'react-native'
import * as React from 'react'
// screens & components
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useLabourStore } from '../../../stores/labour'
import { useCommunicateStore } from '../../../stores/communicate'
import { usePersonalStore } from '../../../stores/personalInfo'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from '../../../stores/home'
import { useclockstore } from '../../../stores/clock'
import { useInitializeStore } from '../../../stores/initialize'
import { useFocusEffect } from '@react-navigation/native'
import MyScrollView from '../../../components/shared/navigator/MyScrollView'
import { clockService } from '../../../services/clockService'

// Custom Subcomponents
import HeaderSection from './components/HeaderSection'
import NavigationCards from './components/NavigationCards'
import UpcomingShiftCard from './components/UpcomingShiftCard'
import CurrentShiftCard from './components/CurrentShiftCard'
import QuickActionsCard from './components/QuickActionsCard'
import ClockInActionsCard from './components/ClockInActionsCard'
import NotificationsCard from './components/NotificationsCard'
import MessagesCard from './components/MessagesCard'
import EarningsCard from './components/EarningsCard'
import { fontPalette } from '../../../static/styles/global'

interface Shift {
  shiftID: number
  time_In: string
}

const LabourScreen = ({ navigation, route }: any) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false)
  const [isClockIn, setClockIn] = React.useState(false)
  const [onBreak, setOnBreak] = React.useState(false)
  const [isClockOut, setClockOut] = React.useState(false)


  const [customerShifts, setCustomerShifts] = React.useState([])
  const [nextshift, setNextshift] = React.useState('')
  const { t } = useTranslation()
  const [refreshing, setRefreshing] = useState(false)
  const [ptoData, setPtoData] = React.useState<any>([])
  const [statusResult, setStatusResult] = React.useState<any>({})


  const { params } = route
  const { mostRecentUserOnBoardings: Id } = params

  const personalstore = usePersonalStore()
  const labourStore = useLabourStore()
  const homeStore = useHomeStore()
  const isClockInFlag = homeStore?.homeData?.isClockIn
  const {
    messages: messages,
    loading: loading,
    error: error,
    fetchAllMessages,
    messagesCount,
    unreadMessage
  } = useCommunicateStore()
  function formattingdate(inputDate: any) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]

    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]

    const dateParts = inputDate?.split('T')[0]?.split('-')
    const year = dateParts[0]
    const month = months[parseInt(dateParts[1], 10) - 1]
    const day = parseInt(dateParts[2], 10)
    const inputDateObject = new Date(inputDate)
    const dayOfWeek = days[inputDateObject.getDay()]
    const nextShiftMessage = `${t('next_shift_starts_on')} ${t(dayOfWeek)}, ${month} ${day}`
    setNextshift(nextShiftMessage)
  }

  const updateddata = () => {
    const backendStartDay = labourStore?.startdayofweekdata?.payPeriodDay
      ? labourStore?.startdayofweekdata?.payPeriodDay
      : 'monday'
    const updatedShifts: any = []

    // ---------- SHIFTS ----------
    if (labourStore?.scheduleData?.shiftInfo) {
      labourStore.scheduleData.shiftInfo.forEach((item) => {
        const date = new Date(item.date)

        const formattedDate = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

        if (!item.onLeave) {
          updatedShifts.push({
            day: formattedDate,
            id: item.shiftID
          })
        }
      })

      setCustomerShifts(updatedShifts)

      // ---------- CURRENT WEEK LOGIC ----------
      const today = new Date()
      const todayDay = today.getDay()
      const weekStartDay = moment().day(backendStartDay).day()

      // Days to go back to reach week start
      const diff = (todayDay - weekStartDay + 7) % 7

      const currentWeekStart = new Date(today)
      currentWeekStart.setDate(today.getDate() - diff)
      currentWeekStart.setHours(0, 0, 0, 0)

      const currentWeekEnd = new Date(currentWeekStart)
      currentWeekEnd.setDate(currentWeekStart.getDate() + 6)
      currentWeekEnd.setHours(23, 59, 59, 999)

      // ---------- FILTER SHIFTS IN CURRENT WEEK (FUTURE ONLY) ----------
      const upcomingShifts = labourStore.scheduleData.shiftInfo.filter(
        (item) => {
          const itemDate = new Date(item.date)
          return (
            itemDate >= currentWeekStart &&
            itemDate <= currentWeekEnd &&
            itemDate > today
          )
        }
      )

      if (upcomingShifts.length > 0) {
        formattingdate(upcomingShifts[0].date)
      }
    }

    // ---------- PTO ----------
    if (labourStore?.scheduleData?.ptoInfo) {
      setPtoData(labourStore.scheduleData.ptoInfo)
    }
  }

  var from = ''
  var to = ''
  const clockstore = useclockstore()
  const intializeStore = useInitializeStore()

  const animated = new Animated.Value(0)
  const duration = 10000

  useEffect(() => {
    Animated.sequence([
      Animated.timing(animated, {
        toValue: 1,
        duration: duration,
        easing: Easing.in(Easing.bounce),
        useNativeDriver: true
      })
    ]).start()
  }, [])

  useEffect(() => {
    // fetchAllMessages(Id)
    const { entityId, corpEntityId } = personalstore?.personalData || {}
    const storeNumber = homeStore?.homeData?.storeNumber

    if (
      entityId !== null &&
      entityId !== undefined &&
      storeNumber !== null &&
      storeNumber !== undefined &&
      corpEntityId !== null &&
      corpEntityId !== undefined
    ) {
      labourStore.announcementsfetchData(entityId, storeNumber, corpEntityId)
    }
  }, [])
  useFocusEffect(
    React.useCallback(() => {
      const fetchData = async () => {
        try {
          if (!isModalVisible) {
            labourStore.getNotification(intializeStore.initializeData.userkey)
          }
        } catch (error) {
          console.log(error)
        }
      }

      fetchData()
    }, [isModalVisible])
  )

  const announcements = labourStore.AnnouncmentsData || []

  const languages = announcements.filter((item) => {
    const postDate = new Date(item?.postDate + 'Z')
    const expDate = new Date(item?.expDate + 'Z')
    const now = new Date()

    return expDate > now && postDate <= now
  })

  const Announcementsmodal = () => {
    const filteredAnnouncements: any = []

    labourStore?.AnnouncmentsData?.forEach((data: any) => {
      const postDate = new Date(data?.postDate + 'Z')
      const expDate = new Date(data?.expDate + 'Z')
      const now = new Date()

      if (data.isActive && expDate > now && postDate <= now) {
        let announcementDescription = ''
        data.announcementDetails?.forEach((de: any) => {
          if (de.language === i18next.language) {
            announcementDescription = de.description
          }
        })
        if (!announcementDescription) {
          data.announcementDetails?.forEach((de: any) => {
            if (de.language === 'ENG') {
              announcementDescription = de.description
            }
          })
        }
        filteredAnnouncements.push({
          description: announcementDescription,
          level: data.level
        })
      }
    })

    return filteredAnnouncements
  }

  useEffect(() => {
    updateddata()
  }, [labourStore?.scheduleData])



  useFocusEffect(
    React.useCallback(() => {
      const { entityId, corpEntityId } = personalstore?.personalData || {}
      const storeNumber = homeStore?.homeData?.storeNumber
      const refreshAPI = async () => {
        labourStore.getNotification(intializeStore.initializeData.userkey)

        if (
          entityId !== null &&
          entityId !== undefined &&
          storeNumber !== null &&
          storeNumber !== undefined &&
          corpEntityId !== null &&
          corpEntityId !== undefined
        ) {
          labourStore.announcementsfetchData(
            entityId,
            storeNumber,
            corpEntityId
          )
        }
        if (homeStore?.homeData?.hasLaborSaver) {
          labourStore.schedulefetchData(
            labourStore?.labourData?.userId
              ? labourStore?.labourData?.userId
              : 0,
            labourStore.startWeekDate,
            labourStore.endWeekDate
          )
        }
        const userKey = Id || intializeStore?.initializeData?.userkey || labourStore?.labourData?.userId
        if (userKey) {
          messagesCount(userKey)
        }
      }

      refreshAPI()
      const intervalId = setInterval(refreshAPI, 60000)
      return () => clearInterval(intervalId)
    }, [labourStore.startWeekDate])
  )

  const announcementsdescription = Announcementsmodal()

  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')

  const formattedDate = `${year}-${month}-${day}`
  const todayshift = customerShifts.filter((item: any) => item.day == formattedDate)
  // const isClockInFlag =
  const todayDate = moment().format('YYYY-MM-DD')
  let shiftdate: any
  let shiftid: any
  let timein: any
  let timeout
  // labourStore?.scheduleData?.shiftInfo?.forEach((item) => {
  //   const itemDate = moment(item.date).format('YYYY-MM-DD')
  //   if (todayDate == itemDate) {
  //     shiftdate = new Date()
  //     shiftid = item.shiftID
  //     timein = item.time_In
  //     timeout = item.time_Out
  //   }
  // })

  // let currenttime = moment().format('HH:mm:ss')
  let isTotalShifts = labourStore?.scheduleData?.shiftInfo?.length
  let isClockInShow =
    homeStore?.homeData?.isClockIn && homeStore?.homeData?.active
  let isclockinStatusNum = clockstore?.clockStatusData?.status?.clockinStatusNum

  let clockinPunched = clockstore?.clockStatusData?.status?.userClockInTime

  const getPreviousStatus = async (
    shiftid: number
  ): Promise<number | undefined> => {
    const data = await clockService.fetchClockinStatus(
      Id,
      shiftid,
      labourStore?.labourData?.employeeNumber,
      labourStore?.labourData?.userId ?? 0,
      moment().format('YYYY-MM-DD')
    )

    return data?.status?.clockinStatusNum
  }

  const todayShifts = useMemo(() => {
    return (
      labourStore?.scheduleData?.shiftInfo
        ?.filter((item) => moment(item.date).format('YYYY-MM-DD') === todayDate)
        ?.sort((a, b) =>
          moment(a.time_In, 'HH:mm:ss').diff(moment(b.time_In, 'HH:mm:ss'))
        ) ?? []
    )
  }, [labourStore?.scheduleData?.shiftInfo, todayDate])
  // console.log("shifts", todayShifts)

  const getClockInStatus = async (
    todayShifts: Shift[],
    currenttime: string
  ): Promise<{
    isClockInShow: boolean
    shiftid: number | null
    timein: string | null
  }> => {
    const current = moment(currenttime, 'HH:mm:ss')

    // 1️⃣ FIRST: check if user is already clocked in on any shift
    for (let i = 0; i < todayShifts.length; i++) {
      const status = await getPreviousStatus(todayShifts[i].shiftID) // API call
      // const status = 2; // API call
      if (status === 2) {
        // still clocked in on this shift → this is the shift we care about
        shiftid = todayShifts[i].shiftID
        timein = todayShifts[i].time_In
        // isclockinStatusNum = 2;
        await clockstore.fetchClockinStatus(
          Id,
          shiftid,
          labourStore?.labourData?.employeeNumber,
          labourStore?.labourData?.userId ?? 0,
          moment().format('YYYY-MM-DD')
        )
        return { isClockInShow, shiftid, timein }
      }
    }

    // console.log(todayShifts)

    for (let i = 0; i < todayShifts.length; i++) {
      const shiftStart = moment(todayShifts[i].time_In, 'HH:mm:ss').subtract(
        homeStore?.homeData?.earlyClockInAllowance,
        'minutes'
      )
      const shiftEnd = moment(todayShifts[i].time_In, 'HH:mm:ss').add(
        homeStore?.homeData?.lateClockInAllowance,
        'minutes'
      )
      // shiftid = todayShifts[i].shiftID
      // timein = todayShifts[i].time_In;
      // console.log("Checking shift:", shiftStart.format('HH:mm:ss'), "-", shiftEnd.format('HH:mm:ss'), "Current:", current.format('HH:mm:ss'));

      if (
        current.isSameOrAfter(shiftStart) &&
        current.isSameOrBefore(shiftEnd)
      ) {
        // Previous shift check
        if (i > 0) {
          const prevStatus: number = await getPreviousStatus(
            todayShifts[i - 1].shiftID
          )
          // const prevStatus: number = 2;

          if (prevStatus === 2) {
            shiftid = todayShifts[i - 1].shiftID
            timein = todayShifts[i - 1].time_In
            clockstore.fetchClockinStatus(
              Id,
              shiftid,
              labourStore?.labourData?.employeeNumber,
              labourStore?.labourData?.userId
                ? labourStore?.labourData?.userId
                : 0,
              moment().format('YYYY-MM-DD')
            )
          } else {
            shiftid = todayShifts[i].shiftID
            timein = todayShifts[i].time_In
            clockstore.fetchClockinStatus(
              Id,
              shiftid,
              labourStore?.labourData?.employeeNumber,
              labourStore?.labourData?.userId
                ? labourStore?.labourData?.userId
                : 0,
              moment().format('YYYY-MM-DD')
            )
          }
        } else {
          shiftid = todayShifts[i].shiftID
          timein = todayShifts[i].time_In
          clockstore.fetchClockinStatus(
            Id,
            shiftid,
            labourStore?.labourData?.employeeNumber,
            labourStore?.labourData?.userId
              ? labourStore?.labourData?.userId
              : 0,
            moment().format('YYYY-MM-DD')
          )
        }

        isClockInShow = true
        break // stop loop
      } else {
        // if (i == 0) {
        //   clockstore.fetchClockinStatus(
        //     Id,
        //     todayShifts[i].shiftID,
        //     labourStore?.labourData?.employeeNumber,
        //     labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
        //     moment().format('YYYY-MM-DD')
        //   )
        // }
        if (i === 0 && current.isBefore(shiftStart)) {
          await clockstore.fetchClockinStatus(
            Id,
            todayShifts[0].shiftID,
            labourStore?.labourData?.employeeNumber,
            labourStore?.labourData?.userId ?? 0,
            moment().format('YYYY-MM-DD')
          )
          break
        }

        // 2️⃣ If current is after this shift’s buffer but before the next shift’s buffer → use this shift
        const nextShift = todayShifts[i + 1]
        if (
          nextShift &&
          current.isAfter(shiftEnd) &&
          current.isBefore(
            moment(nextShift.time_In, 'HH:mm:ss').subtract(
              homeStore?.homeData?.earlyClockInAllowance,
              'minutes'
            )
          )
        ) {
          await clockstore.fetchClockinStatus(
            Id,
            todayShifts[i].shiftID, // previous shift
            labourStore?.labourData?.employeeNumber,
            labourStore?.labourData?.userId ?? 0,
            moment().format('YYYY-MM-DD')
          )
          break
        }

        // 3️⃣ If we are after the last shift’s buffer → use the last shift
        if (i === todayShifts.length - 1 && current.isAfter(shiftEnd)) {
          await clockstore.fetchClockinStatus(
            Id,
            todayShifts[i].shiftID, // last shift of the day
            labourStore?.labourData?.employeeNumber,
            labourStore?.labourData?.userId ?? 0,
            moment().format('YYYY-MM-DD')
          )
          break
        }
      }
    }

    return { isClockInShow, shiftid, timein }
  }

  // Inside an async function or useEffect
  useEffect(() => {
    const check = async () => {
      // const currentTime = '21:30:00';
      const currentTime = moment().format('HH:mm:ss')
      const result = await getClockInStatus(todayShifts, currentTime)
      // console.log("result", result); // { isClockInShow: true/false, shiftid: ..., timein: ... }

      setStatusResult(result)
      isClockInShow = statusResult?.isClockInShow
      shiftid = statusResult?.shiftid
      timein = statusResult?.timein
    }

    if (homeStore?.homeData?.isClockIn && homeStore?.homeData?.active) {
      check()
    }
  }, [todayShifts])

  // console.log("clock", isClockInShow)
  // console.log("shiftid", statusResult?.shiftid)
  // console.log("shiffffffffffffffttttttttt", shiftid);

  shiftid = statusResult?.shiftid
  isClockInShow = statusResult?.isClockInShow
  // isclockinStatusNum = statusResult?.isclockinStatusNum

  useEffect(() => {
    const getclockstatus = async () => {
      clockstore.fetchClockinStatus(
        Id,
        shiftid,
        labourStore?.labourData?.employeeNumber,
        labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
        moment().format('YYYY-MM-DD')
      )
    }
    if (shiftid != undefined) {
      getclockstatus()
    }
  }, [labourStore.scheduleData])
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      const getclockstatus = async () => {
        clockstore.fetchClockinStatus(
          Id,
          shiftid,
          labourStore?.labourData?.employeeNumber,
          labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
          moment().format('YYYY-MM-DD')
        )
      }
      if (shiftid != undefined) {
        getclockstatus()
      }
    })
    return unsubscribe
  }, [labourStore?.scheduleData])

  const [showAllNotifications, setShowAllNotifications] = useState(false)

  let notifications = labourStore?.notificationData?.groups || []

  const displayedNotifications = showAllNotifications
    ? notifications
    : notifications.slice(0, 3)

  const { width: DEVICE_WIDTH } = Dimensions.get('window')

  const onRefresh = React.useCallback(() => {
    setRefreshing(true)
    setTimeout(() => {
      navigation.replace('LabourScreen', { refresh: Math.random() })
      setRefreshing(false)
    }, 1000)
  }, [])

  let intialLength = 0

  let ids: any = []
  labourStore?.notificationData?.groups?.map((data, index) => {
    if (index < 3) {
      intialLength = intialLength + data?.count
    }
    return data?.notifications?.map((item) => {
      return ids.push(item.notificationKey)
    })
  })

  const data = {
    notificationKey: ids
  }

  const handlemarkasread = async () => {
    const response = await labourStore.markallasread(data)
    if (response?.success) {
      onRefresh()
    }
  }

  useEffect(() => {
    if (personalstore?.personalData?.employeeEmailAddress) {
      labourStore.switchaccount(
        personalstore?.personalData?.employeeEmailAddress
      )
    }
  }, [personalstore?.personalData])

  // console.log("isclockinStatusNum", isclockinStatusNum);

  //console.log("unread", unreadMessage?.data?.count)

  return (
    <MyScrollView
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      <HeaderSection
        firstName={personalstore?.personalData?.firstName}
        brandingLogo={homeStore?.homeData?.brandingLogo}
        navigation={navigation}
      />

      <View style={styles.contentContainer}>
        {/* Greetings Section */}
        <View style={styles.greetingSection}>
          <Text style={styles.greetingTitle}>
            {moment().hour() < 12
              ? t('Good morning')
              : moment().hour() < 17
                ? t('Good afternoon')
                : t('Good evening')}
            {personalstore?.personalData?.firstName
              ? `, ${personalstore.personalData.firstName}!`
              : '!'}
          </Text>
          <Text style={styles.greetingSubtitle}>
            {t("Here's what's happening today.")}
          </Text>
        </View>

        {/* Clock In Actions Card */}
        {homeStore?.homeData?.hasLaborSaver && homeStore?.homeData?.active && todayShifts && todayShifts.length > 0 && (
          <ClockInActionsCard
            navigation={navigation}
            t={t}
            shiftid={shiftid}
            timein={timein}
            isClockInShow={isClockInShow}
            isClockInFlag={homeStore?.homeData?.isClockIn}
            clockstore={clockstore}
            setOnBreak={setOnBreak}
            setClockIn={setClockIn}
            setClockOut={setClockOut}
          />
        )}

        {/* Top Navigation Row of 3 Cards: My Schedule, Timecard, Announcements */}
        {homeStore?.homeData?.active &&
          <NavigationCards
            navigation={navigation}
            customerShifts={customerShifts}
            announcementsCount={languages.length}
            hasLabourSavour={homeStore?.homeData?.hasLaborSaver}

          />
        }

        {homeStore?.homeData?.hasLaborSaver && homeStore?.homeData?.active
          &&
          <UpcomingShiftCard
            shiftInfo={labourStore?.scheduleData?.shiftInfo}
            navigation={navigation}
          />}


        {/* Quick Actions Card */}
        {homeStore?.homeData?.active && (
          <QuickActionsCard
            navigation={navigation}
            hasLaborSaver={homeStore?.homeData?.hasLaborSaver}
            isPTORequestAllowed={homeStore?.homeData?.isPTORequestAllowed}
            hasDefaultAvailability={homeStore?.homeData?.hasDefaultAvailability}
          />
        )}

        {/* Notifications Card */}
        {homeStore?.homeData?.active && (
          <NotificationsCard
            notifications={notifications}
            displayedNotifications={displayedNotifications}
            showAllNotifications={showAllNotifications}
            setShowAllNotifications={setShowAllNotifications}
            handlemarkasread={handlemarkasread}
            notificationCount={labourStore?.notificationData?.notificationCount || 0}
            initialLength={intialLength}
            t={t}
          />
        )}

        {/* Messages Card */}
        {homeStore?.homeData?.active && (
          <MessagesCard
            messages={messages}
            navigation={navigation}
            t={t}
            unreadMessage={unreadMessage}
          />
        )}

        {/* Earnings & Payroll Documents Card */}
        <EarningsCard
          navigation={navigation}
          clockinStatusNum={isclockinStatusNum}
          hasLaborSaver={homeStore?.homeData?.hasLaborSaver}
          isActive={homeStore?.homeData?.active}
        />
      </View>
    </MyScrollView>
  )
}

export default LabourScreen

const styles = StyleSheet.create({
  contentContainer: {
    backgroundColor: '#F5F5F5',
    paddingBottom: 24
  },
  greetingSection: {
    alignItems: 'center',
    marginTop: 18,
    marginBottom: 8,
    paddingHorizontal: 16
  },
  greetingTitle: {
    fontSize: 22,
    color: '#111',
    textAlign: 'center',
    fontFamily: fontPalette.primaryBold
  },
  greetingSubtitle: {
    fontSize: 13,
    color: '#666',
    marginTop: 4,
    textAlign: 'center',
     fontFamily: fontPalette.primaryRegular
  }
})
